/**
 * Created by vladislav on 7/14/2025
 */

const Multiplayer = function () {
    this.cups = new Cups();
    this.bots = new MultiBots();
    this.leagues = new MultiLeagues();
    this.requests = new MultiplayerRequests();
    this.rewardedpromo = new MultiRewardedPromo();
};

Multiplayer.prototype.getCountry = function (callback) {
    ConnectorRestClient.get(`${connector.config.multiApiURL}/country`, {}, (response) => {
        const countryCode = response && response.countryCode;

        callback(true, countryCode);
    }, () => {
        callback(false);
    });
};

connector.multi = new Multiplayer();